import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import WithProgression from '../../../bundles/common/components/Wrappers/WithProgression';

/**
 * LogoHoriProgressive - Responsive logo with progressive loading
 *
 * Combines native browser features with progressive loading:
 * - Starts with 500px image (low quality) for fast initial load
 * - Progresses to larger version (high quality) after page load
 * - Uses srcset on high-quality image for responsive optimization
 * - Leverages IntersectionObserver for lazy loading detection
 *
 * Breakpoints (from ViewLanding.js):
 * - Small (< 600px): 65vw
 * - Medium (600px-899px): 55vw
 * - Large (≥ 900px): 28vw
 */
export default function LogoHoriProgressive({ width = '100px' }) {
    const theme = useContext(ThemeContext);

    // Determine theme variant (dark or bright)
    const isDark = theme.current === 'dark';

    const basePath = isDark
        ? '/logo/logo-full-horizontal-transparent-bright'
        : '/logo/logo-full-horizontal-transparent-dark';

    // Low quality: Always start with 500px for fast initial load
    // const lowQualitySrc = `${basePath}-500px.png`;
    const lowQualitySrcSet = `${basePath}-500px.png 500w, ${basePath}-1000px.png 1000w`;

    // High quality: Use larger version with srcset for browser optimization
    // Browser will select from 1000w, 1500w, 2000w based on viewport and DPR
    // const highQualitySrc = `${basePath}-1500px.png`; // Fallback
    const highQualitySrcSet = `${basePath}-1500px.png 1500w, ${basePath}-2000px.png 2000w`;

    // Sizes attribute tells browser how much space the image will take up at different breakpoints
    // This matches the breakpoints from ViewLanding.js:
    // - Small (< 600px): 65vw
    // - Medium (600px-899px): 55vw
    // - Large (≥ 900px): 28vw
    const sizes = '(max-width: 599px) 65vw, (max-width: 899px) 55vw, 28vw';

    return (
        <WithProgression
            // lowQualitySrc={lowQualitySrc}
            lowQualitySrcSet={lowQualitySrcSet}
            // highQualitySrc={highQualitySrc}
            highQualitySrcSet={highQualitySrcSet}
            sizes={sizes}
            alt="EZSplit Logo"
            style={{ width: width, display: 'block' }}
            loading="eager" // Logo is above the fold, so load immediately
        />
    );
}
